import PublicLayout from "@/components/PublicLayout";

export default function About() {
  return (
    <PublicLayout>
      <section className="gradient-radial-blue">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="section-label">About</div>
          <h1 className="mt-2 font-display font-bold text-4xl sm:text-5xl text-[#0A192F]">Trusted filing partner for individuals &amp; businesses</h1>
          <p className="mt-5 text-lg text-slate-600 leading-relaxed">
            Way2Efiling is a service platform operated by <span className="font-semibold text-[#0A192F]">SHREE ADARSH INFOTECH</span> — a registered business in Rajasthan (GSTIN <span className="font-mono">08KKOPS0455P1Z2</span>). We help individuals, freelancers, MSMEs and startups stay compliant with Indian tax and licensing regulations.
          </p>
        </div>
      </section>
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-8">
          <div>
            <h2 className="font-display font-semibold text-2xl text-[#0A192F]">Our mission</h2>
            <p className="text-slate-600 mt-2 leading-relaxed">Make tax filing and business licensing effortless for every Indian — with expert guidance, transparent pricing, and delivery on time.</p>
          </div>
          <div>
            <h2 className="font-display font-semibold text-2xl text-[#0A192F]">Our services</h2>
            <p className="text-slate-600 mt-2 leading-relaxed">Digital Signature, ITR Filing, GST Registration, Udyam/MSME Registration and FSSAI Licensing </p>
          </div>
          <div>
            <h2 className="font-display font-semibold text-2xl text-[#0A192F]">Registered office</h2>
            <p className="text-slate-600 mt-2 leading-relaxed">SHREE ADARSH INFOTECH, Q1 &amp; Q2, Jain Building, Main Market, Sandiya, Sojat, Pali, Rajasthan – 306306, India.</p>
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
